import React, { useEffect, useState } from "react";
import { AntdButton, Inner, Section, MessageContainer, AgentInfo } from "./styles.js";
import { CONSTANTS, Typo } from "../../components/layout/theme/index.js";
import { DownloadOutlined, ReloadOutlined, CheckCircleOutlined, PhoneOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useReport } from "../../contexts/ReportContext.js";
import { useFilter } from "../../contexts/FilterContext.js";
import { clear_real_quotations } from "../../api/endpoints/quotations.js";
import moment from "moment";
import { useMatomo } from "@datapunt/matomo-tracker-react";

const Congratulations = () => {
	const navigate = useNavigate();
	const { selectedQuotation, resetFilters } = useFilter();
	const { reportForm, resetForm } = useReport();
	const { trackEvent } = useMatomo();
	const [communicationStatus, setCommunicationStatus] = useState("loading");

	useEffect(() => {
		const sendData = async () => {
			const completeData = {
				// Información del proceso
				processInfo: {
					timestamp: moment().toISOString(),
					date: moment().format("DD/MM/YYYY HH:mm:ss"),
					processId: `QUOTE_${Date.now()}`,
					status: "completed",
				},

				// Datos del vehículo
				vehicleData: {
					...reportForm.carData,
					location: reportForm.carLocation,
					specialFeatures: reportForm.carSpecialFeatures,
				},

				// Plan seleccionado
				selectedPlan: {
					...selectedQuotation,
					quotationId: reportForm.quotationData.quotationId,
				},

				// Datos personales de cotización
				quotationPersonalData: reportForm.quotationPersonalData,

				// Datos personales de emisión
				emissionPersonalData: reportForm.emissionPersonalData,

				// Método de pago
				paymentMethod: reportForm.emissionPaymentMethod,

				// Información completa del reporte
				fullReport: reportForm,
			};

			console.log("=== DATOS COMPLETOS DEL PROCESO DE VENTA ===");
			console.log(JSON.stringify(completeData, null, 2));
			console.log("=== FIN DE DATOS ===");

			try {
				const response = await fetch(process.env.REACT_APP_WEBHOOK_URL, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(completeData),
				});

				if (response.status === 200) {
					setCommunicationStatus("success");
				} else {
					setCommunicationStatus("error");
				}
			} catch (error) {
				console.error("Error sending data to webhook:", error);
				setCommunicationStatus("error");
			}
		};

		sendData();
	}, [reportForm, selectedQuotation]);

	const handleDownload = () => {
		const report = {
			...reportForm,
			insuranceData: selectedQuotation,
			date: moment().format("DD/MM/YYYY").toString(),
		};

		const reportContent = CONSTANTS.getReportDownload(report);

		const printWindow = window.open("", "", "height=800,width=1000");
		printWindow.document.write(
			"<html><head><title>Cotización</title></head><body>"
		);
		printWindow.document.write(reportContent);
		printWindow.document.write("</body></html>");
		printWindow.document.close();
		printWindow.print();
	};
	
	const handleRepeatProcess = () => {
		trackEvent({
			category: "button-click",
			action: "finish-button",
			name: "step4.finish",
		});
		
		// Limpiar caché de cotizaciones para evitar mostrar cotizaciones antiguas
		clear_real_quotations();
		
		// Resetear filtros y formularios
		resetFilters();
		resetForm();
		
		// Navegar al inicio
		navigate("/");
	};

	return (
		<Inner>
			<MessageContainer>
				<CheckCircleOutlined style={{ fontSize: '48px', color: '#52c41a', marginBottom: '16px' }} />
				<Typo level={1} style={{ color: '#52c41a', marginBottom: '8px' }}>
					¡Felicitaciones!
				</Typo>
				<Typo level={3} style={{ textAlign: 'center', marginBottom: '16px' }}>
					Tu solicitud de seguro ha sido procesada exitosamente
				</Typo>
				<Typo level={4} style={{ textAlign: 'center', color: '#666', marginBottom: '24px' }}>
					Hemos recibido toda tu información y estamos procesando tu póliza
				</Typo>
			</MessageContainer>

			<AgentInfo>
				<PhoneOutlined style={{ fontSize: '24px', color: '#1890ff', marginBottom: '12px' }} />
				{communicationStatus === "loading" && (
					<Typo level={3} style={{ color: '#1890ff', marginBottom: '8px' }}>
						Procesando...
					</Typo>
				)}
				{communicationStatus === "success" && (
					<>
						<Typo level={3} style={{ color: '#1890ff', marginBottom: '8px' }}>
							¡Pronto nos comunicaremos contigo!
						</Typo>
						<Typo level={5} style={{ textAlign: 'center', lineHeight: '1.6' }}>
							Uno de nuestros agentes especializados se pondrá en contacto contigo
							en las próximas horas para finalizar el proceso y resolver cualquier consulta.
						</Typo>
					</>
				)}
				{communicationStatus === "error" && (
					<Typo level={3} style={{ color: 'red', marginBottom: '8px' }}>
						La comunicación con el servicio de asistencia falló.
					</Typo>
				)}
			</AgentInfo>

			<Section style={{ maxWidth: "320px", maxHeight: "100px" }}>
				<AntdButton key="PrevStep2CarParsonalData" onClick={handleDownload}>
					<Typo level={5}>
						<DownloadOutlined /> Descargar
					</Typo>
				</AntdButton>
				<AntdButton
					key="NextStep2CarPersonalData"
					type="primary"
					onClick={handleRepeatProcess}
				>
					<Typo level={5} type="white">
						<ReloadOutlined /> Cotizar otro seguro
					</Typo>
				</AntdButton>
			</Section>
		</Inner>
	);
};

export default Congratulations;
